module.exports = __webpack_public_path__ + "media/images/pencil-6a3806c8a9b96f4dfc0ac3142dd9c399.gif";